<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <GmapMap
      :center="{ lat: 10, lng: 10 }"
      :zoom="7"
      map-type-id="terrain"
      style="width: 500px; height: 300px"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="{ lat: parseFloat(m.lat), lng: parseFloat(m.long) }"
        :clickable="true"
        :draggable="true"
        @click="center = { lat: parseFloat(m.lat), lng: parseFloat(m.long) }"
      />
    </GmapMap>
  </div>
</template>

<script>
import { getloactions } from "../config/apiRoute.js";
export default {
  data: () => ({
    loading: false,
    user: [],
    permissions: [],
    markers: []
  }),

  computed: {},

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    getloactions().then(res => {
      this.markers = res.data;
      console.log("locationssssssssss", this.markers);
    });
  },

  methods: {}
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
